"use strict";
function supportsFeatures() {
    return typeof ResizeObserver === 'function'
        && typeof CSS === 'object'
        && CSS.supports('--fake-var', '0')
        && typeof Promise === 'function'
        && typeof fetch === 'function'
        && typeof Proxy === 'function';
}
function blockOldIOS() {
    const match = navigator.userAgent.match(/OS (\d+)_/);
    if (match && Number(match[1]) < 14) {
        return true;
    }
    return false;
}
function showMessage(message) {
    document.documentElement.classList.add('browser-unsupported');
    document.body.innerHTML = '';
    const main = document.createElement('main');
    main.style.fontFamily = '"Helvetica Neue", Arial, sans-serif';
    main.style.minHeight = '100vh';
    main.style.display = 'flex';
    main.style.justifyContent = 'center';
    main.style.alignItems = 'center';
    main.style.textAlign = 'center';
    main.style.padding = '2rem';
    main.style.background = '#060912';
    main.style.color = '#fff';
    const wrapper = document.createElement('div');
    const heading = document.createElement('h1');
    heading.textContent = 'Browser not supported';
    const text = document.createElement('p');
    text.textContent = message;
    wrapper.appendChild(heading);
    wrapper.appendChild(text);
    main.appendChild(wrapper);
    document.body.appendChild(main);
}
if (!supportsFeatures()) {
    showMessage('This experience requires a modern browser with ResizeObserver and CSS Variables (Safari 13.4+/Chrome 64+). Please upgrade.');
    throw new Error('Unsupported browser');
}
if (blockOldIOS()) {
    showMessage('iOS 14 or later is required. Please upgrade your device or use another browser.');
    throw new Error('Unsupported iOS');
}
